import {
  getMiloDeeplink,
  getTransferEndpoints,
  updateContactReleaseToAIL,
  getContactEventLoggingAPIHandler,
} from "../api/session-api";
import {
  API_CALL_ANSWER,
  INTERNAL_CALL_RELEASE,
  STATE_CALL,
  API_MILO_CHANNEL_TRANSACTION,
  ATTACH_CONTACT_TO_CALLBACK,
} from "../constants/events";

import {
  isDialCallInProgress,
  resetNormalCall,
  updateNormalCall,
  updateTransferEndpoints,
} from "../actions/call";
import storeRTK from "../store/storeRTK";
import Emitter from "../emitter";
import { callPlayer } from "../amazon-connect/handlers/call";
import { historyInitialiseHandler } from "./history";
import { setSelectedTab } from "../actions/common";
import { notificationManager } from "../utils/NotificationManager";
import { SessionEvent } from "../types/call.type";
import { DIAL_CALL_IN_PROGRESS } from "../constants/action-types";

export async function callHandler(event: any) {
  const callPresent = storeRTK.getState().call.id;
  if (
    event?.self?.state !== "RINGING" &&
    event?.self?.direction != "OUTBOUND"
  ) {
    if (callPresent) {
      callPlayer.pause();
      notificationManager.stopFaviconBlinking();
    }
  }
  if (event?.self?.state) {
    if (event.self?.state == "RELEASED") {
      const cstate = storeRTK.getState();
      if (cstate.call.id === event.id) {
        Emitter.emit(INTERNAL_CALL_RELEASE, event);
        storeRTK.dispatch(resetNormalCall());
        Emitter.emit(STATE_CALL, { body: event });
        updateContactReleaseToAIL(
          "voice",
          event.id as string,
          event.customer?.phoneNumber || ""
        );
      } else {
        //if call disconnected from CCP but visible in UI
        historyInitialiseHandler();
        storeRTK.dispatch(resetNormalCall());
        Emitter.emit(STATE_CALL, { body: event });
      }
    } else if (event.self?.state == "TERMINATED") {
      //Do nothing
    } else if (event) {
      const callNotPresent = !storeRTK.getState().call.id;
      if (event.self?.state == "DIALING") {
        getContactEventLoggingAPIHandler(event?.id ?? "", "DIALING");
        Emitter.emit(ATTACH_CONTACT_TO_CALLBACK);
      }
      storeRTK.dispatch(updateNormalCall(event));

      if (callNotPresent) {
        const state = storeRTK.getState();
        const { self } = state.call;
        const callId = state.call?.id;
        if (self?.direction != "OUTBOUND") {
          getContactEventLoggingAPIHandler(event?.body?.id ?? "", "RINGING");
          notificationManager.playRingtone(callPlayer);
          notificationManager.startFaviconBlinking();
          storeRTK.dispatch(setSelectedTab("Call"));
          notificationManager.show("You have an incoming call", {
            body: "Click or open AIC Web to answer it",
            icon: "icon.png",
            onclick: () => {
              Emitter.emit(API_CALL_ANSWER, {
                body: { conversationId: callId },
              });
            },
          });
        }
      }
    }
  }
}

async function miloHandlerEvent(ev: SessionEvent<any>) {
  const miloEvent = {
    body: {
      phoneNumber: ev.body.phoneNumber,
      contactId: ev.body.contactId,
    },
  };
  notificationManager.triggerMilo(miloEvent, "call");
}

export async function miloHandler(ev: any) {
  const miloDeeplink = await getMiloDeeplink(
    "voice",
    ev.body?.contactId,
    ev.body?.phoneNumber
  );
  if (miloDeeplink) {
    // put timeout because milo can come immediately and bg state may not be updated till then.
    setTimeout(() => {
      window.open(miloDeeplink, "_blank");
    }, 100);
  }
}

export async function setTransferEndpoints(contactId: string | undefined) {
  if (contactId) {
    const allowedTransferEndpoints = await getTransferEndpoints(contactId);
    storeRTK.dispatch(updateTransferEndpoints(allowedTransferEndpoints));
  } else {
    console.log("Error: error in setting transfer endpoints");
  }
}

const handleCalldialProgress = () => {
  storeRTK.dispatch(isDialCallInProgress(false));
};

// async function loggingHandlerEvent(ev: SessionEvent<any>) {
//   const loggingEvent = {
//     body: {
//       contactId: ev.body?.contactId,
//       eventType: ev.body?.eventType,
//     },
//   };
//   notificationManager.eventLoggingAPI(loggingEvent, "call");
// }

// export async function contactEventHandler(ev: SessionEvent<any>) {
//   getContactEventLoggingAPIHandler(ev.body?.contactId, ev.body?.eventType);
// }

export default function registerCallHandlers() {
  Emitter.on(STATE_CALL, callHandler);
  Emitter.on(API_MILO_CHANNEL_TRANSACTION, miloHandlerEvent);
  Emitter.on(DIAL_CALL_IN_PROGRESS, handleCalldialProgress);
  // Emitter.on(API_CONTACT_EVENT_LOGGING, loggingHandlerEvent);
}
